import React, { useState } from "react";

import BankTransfersView from "./BankTransfersView";
import BankFlowsView from "./BankFlowsView";
import BankMonthVerificationView from "./BankMonthVerificationView";

import "../../../css/BankingView.css";

const BankingView = () => {
    const [activeTab, setActiveTab] = useState("transfers");

    return (
        <div className="banking-view">
            <div className="banking-head">Operacje finansowe</div>

            <div className="banking-wrap">
                <div className="banking-tabs">
                    <div className={`banking-tab ${activeTab === "transfers" ? "is-active" : ""}`} onClick={() => setActiveTab("transfers")}>Przelewy</div>
                    <div className={`banking-tab ${activeTab === "flows" ? "is-active" : ""}`} onClick={() => setActiveTab("flows")}>Przepływy</div>
                    <div className={`banking-tab ${activeTab === "verification" ? "is-active" : ""}`} onClick={() => setActiveTab("verification")}>Kontrola miesiąca</div>
                </div>

                <div className="banking-content">
                    {activeTab === "transfers" && <BankTransfersView />}
                    {activeTab === "flows" && <BankFlowsView />}
                    {activeTab === "verification" && <BankMonthVerificationView />}
                </div>
            </div>
        </div>
    );
};

export default BankingView;